import { render, staticRenderFns } from "./MultiIrrSummaryComponent.vue?vue&type=template&id=4f5448c3"
import script from "./MultiIrrSummaryComponent.vue?vue&type=script&lang=js"
export * from "./MultiIrrSummaryComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports